// @flow

// COMMON: Komponenta, ktera zajistuje, ze se vertikalni menu zobrazi vzdy pouze v jednom radku (odeberte, pokud na hlavni navigaci nepouzivate)
// import GreedyMenu from 'fg-frontend/components/GreedyMenu';

// COMMON: Komponenta webslideru (odeberte, pokud tuto promitacku nepouzivate)
// import Webslider from 'fg-frontend/src/components/Webslider';

// COMMON: Komponenta tlacitka Nacist dalsi v ramci strankovani
// import UniversalPaginationButton from 'fg-frontend/components/UniversalPaginationButton';

// COMMON: Ostylovani select inputu pomoci knihovny Select2 (odeberte, pokud ostylovani nepouzivate)
// import SelectDesign from './components/SelectDesign';

// COMMON: Napovedne popupy (odeberte, pokud v projektu nepouzivate, na eshopu napriklad na napovedy k parametrum a jako obecna knihovna pro zobrazovani napovednych textu)
// import Tooltip from './components/Tooltip';

// COMMON: Komponenta, ktera upoznuje posilat do GTM Datalayeru zaznamu na zaklade zapisu v data atributech (odeberte, pokud GTM nepouzivate, jinak vyuzito primarne v eshopu)
// import GtmHandler from './components/GtmHandler';

// COMMON: Komponenta, ktera vystreli specialni udalost v okamziku, kdy se objevi ve viewportu (pomocna komponenta pro GtmHandler, odeberte, pokud nepouzivate GTMHandler]
// import TriggerInViewport from './components/TriggerInViewport';

// COMMON: Komponenta, ktera nastavi obrazek do rezimu lazy (odeberte, pokud nepouzivate lazy obrazky)
// import LazyImage from './components/LazyImage';

// COMMON: Komponenta pro prepinani HTML tridy na danem elementu
// import Toggler from './components/Toggler';

// COMMON: Komponenta pro osetreni informacnich boxu (odeberte, pokud nepouzivate funkcionalitu/extenzi AlertBox)
// import AlertBox from 'fg-frontend/src/components/AlertBox';

// COMMON: Komponenta pro odpocet
// import Countdown from './components/Countdown';

// COMMON: Komponenta pro rozbaleni dalsich fotografii (TODO PDU: nahradit obecnejsi komponentou ListToggle)
// import ShowMorePhotos from './components/ShowMorePhotos'

// COMMON: Komponenta pro AJAX nacteni SVG spritu
// import AddSvgIconSprite from './components/AddSvgIconSprite';

// COMMON: Všeobecná komponenta pro využití JS na globalní úrovni
// import WebLayout from './components/WebLayout';

// COMMON: Komponenta pro nacteni zakladniho instagram feedu
// import InstagramFeed from './components/InstagramFeed';

// COMMON: Komponenta pro zobrazení galerie
// import PhotoSwipe from "./components/PhotoSwipe";

// COMMON: Komponenta pro zobrazení dodatečného inputu ve Scramjet komponentě pro hodnocení po kliknutí na radio input 'Jiná odpověď'
import ScramjetScaleSelect from './components/ScramjetScaleSelect';

// Komponenty pouzite primarne v eshopu (odkomentujte v pripade eshopu, ale pozor obsahuje i univerzalne pouzitelne komponenty, pokud potrebujete, nebojte se pouzit - tj. presunout sem)
// import configureEshopComponents from './configureEshopComponents';

export default (props) => {
  switch (props.decorator || props.is) {
    // case 'Typeahead':
      // COMMON: Komponenta obecneho naseptavace (odeberte, pokud nepouzivate RJ komponentu typeahead nebo v eshopu vychozi naseptavace pobocek dopravnich spolecnosti)
      // return import('fg-frontend/components/Typeahead');
    // case 'PasswordToggle':
      // COMMON: Komponenta pro zapnuti/vypnuti viditelnosti vkladaneho hesla (odeberte, pokud nepouzivate registration modul)
      // return import('fg-frontend/components/PasswordToggle');
    // case 'SocialShare':
      // COMMON: Komponenta pro sdileni linku na socialni site (odeberte, pokud nepouzivate sdileni linku na socialni site, napr. v eshopu v detailu produktu)
      // return import('fg-frontend/src/components/SocialShare');
    // case 'FGUpload':
      // COMMON: Komponenta pro multi upload souboru (odeberte, pokud nepouzivate RJ fileUpload komponentu)
      // return import('./components/FGUpload');
    // case 'CloseableAlert':
      // COMMON: Zaviratelny alert (odeberte pokud na komponente messages nepouzivate moznost zavreni)
      // return import('fg-frontend/src/components/CloseableAlert');
    case 'GoogleRecaptcha':
      // COMMON: Google Recaptcha (odeberte pokud neupouzivate komponentu Google Recaptcha)
      return import('fg-frontend/src/components/GoogleRecaptcha');
    default:
      const eshopComponent = configureEshopComponents(props);
      if (eshopComponent) {
        return eshopComponent;
      } else {
        console.log(`Unknown component ${props.decorator || props.is}`);
        return null;
      }
  }
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureWebComponents.js